// Billing Subscription Cancel
export const BILLING_SUBSCRIPTION_CANCEL_REQUEST = 'BILLING_SUBSCRIPTION_CANCEL_REQUEST';
export const BILLING_SUBSCRIPTION_CANCEL_DONE = 'BILLING_SUBSCRIPTION_CANCEL_DONE';
export const BILLING_SUBSCRIPTION_CANCEL_FAILED = 'BILLING_SUBSCRIPTION_CANCEL_FAILED';
export const BILLING_SUBSCRIPTION_CANCEL_RESET = 'BILLING_SUBSCRIPTION_CANCEL_RESET';
